import { render, staticRenderFns } from "./OperaShopApproveWindow.vue?vue&type=template&id=0cd143dc&scoped=true&"
import script from "./OperaShopApproveWindow.vue?vue&type=script&lang=js&"
export * from "./OperaShopApproveWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaShopApproveWindow.vue?vue&type=style&index=0&id=0cd143dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd143dc",
  null
  
)

export default component.exports